<template>
    <rkm-overlay>
        <rkm-layout-body title="C6 - Cuidado da pessoa idosa">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/atencao-basica/relatorio-cuidado-pessoa-idosa/List'

export default {
    components: { List },
}
</script>